import React from 'react'
import OB from './index'

const Onboarding = () => {
    return (
        <>
        <OB />
        </>
    )
}

export default Onboarding
